import React from 'react'

export interface ErrorBoundaryProps {
  children: React.ReactNode,
  onError: (error: Error, errorInfo: React.ErrorInfo) => void,
}

class ErrorBoundary extends React.Component<ErrorBoundaryProps> {
  componentDidCatch(error: Error, errorInfo: React.ErrorInfo) {
    this.props.onError(error, errorInfo)
  }
  
  render() {
    return this.props.children
  }  
}

export default ErrorBoundary


// WEBPACK FOOTER //
// ./src/view/ErrorBoundary.tsx